import {
  Dispatch,
  SetStateAction,
} from 'react';
import useUrlSyncState from 'pages/Dashboard/hooks/useUrlSyncState';
import {
  formatDateOnly,
  getDateRangeFromStringParam,
} from 'utils/date';
import dayjs from 'utils/dayjs';
import {
  DateUnit,
} from 'utils/misc';
import {
  DateRange,
} from 'types/dateRange';

export type DateRangeParams = {
  unit?: DateUnit;
  amount?: number;
  uniqueKey?: string;
  defaultDateRange?: DateRange;
};

export function useSyncDateRange({
  unit = 'month',
  amount = 3,
  uniqueKey,
  defaultDateRange,
}: DateRangeParams) {
  const now = dayjs();
  const resolvedDefaultDateRange: DateRange = defaultDateRange ?? {
    min: now.subtract(amount, unit).startOf('day').toDate(),
    max: now.endOf('day').toDate(),
  };

  return useUrlSyncState<DateRange>(
    resolvedDefaultDateRange,
    'dates',
    // convertStateToQueryParam
    (value) => `${formatDateOnly(value.min)}--${formatDateOnly(value.max)}`,
    // convertQueryParamToState
    (param) => getDateRangeFromStringParam(param) ?? resolvedDefaultDateRange,
    uniqueKey,
  );
}

type SearchQueryParams = {
  storageKey?: string;
};

type SearchQueryState = {
  searchQuery: string;
  setSearchQuery: Dispatch<SetStateAction<string>>;
};

export function useSyncSearchQuery({
  storageKey,
}: SearchQueryParams = {}): SearchQueryState {
  const [searchQuery, setSearchQuery] = useUrlSyncState<string>(
    '',
    'search',
    (value) => value,
    (param) => param,
    storageKey,
  );

  return {
    searchQuery,
    setSearchQuery,
  };
}
